import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

interface MagicLinkLoginProps {
  onClose: () => void;
}

const MagicLinkLogin: React.FC<MagicLinkLoginProps> = ({ onClose }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);
  const { signInWithEmail } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setMessage({ type: 'error', text: 'Please enter your email address' });
      return;
    }

    setLoading(true);
    setMessage(null);

    const { error } = await signInWithEmail(email);
    
    if (error) {
      setMessage({ type: 'error', text: error.message });
    } else {
      setMessage({ type: 'success', text: 'Check your email for the magic link!' });
      setTimeout(() => {
        onClose();
      }, 3000);
    }
    
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-black border-2 border-white p-6 max-w-md w-full">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-white">Sign In</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <i className="fa-solid fa-times"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 bg-black border-2 border-gray-600 text-white focus:outline-none focus:border-white transition-colors"
              placeholder="you@example.com"
              disabled={loading}
            />
          </div>

          {message && (
            <div className={`p-3 border-2 ${message.type === 'success' ? 'border-green-500 text-green-400' : 'border-red-500 text-red-400'}`}>
              {message.text}
            </div>
          )}

          <button
            type="submit"
            className="paint-button w-full"
            disabled={loading}
          >
            {loading ? (
              <>
                <i className="fa-solid fa-spinner fa-spin mr-2"></i>
                Sending Magic Link...
              </>
            ) : (
              <>
                <i className="fa-solid fa-envelope mr-2"></i>
                Send Magic Link
              </>
            )}
          </button>

          <p className="text-xs text-gray-400 text-center">
            We'll send you a magic link to sign in. No password needed!
          </p>
        </form>
      </div>
    </div>
  );
};

export default MagicLinkLogin;